import { gql } from '@apollo/client';

const TASK_LIST_SECTION_TEMPLATE_DELETE = gql`
  mutation taskListSectionTemplateDelete(
    $input: TaskListSectionTemplateDeleteInput!
  ) {
    taskListSectionTemplateDelete(input: $input) {
      deletedId
    }
  }
`;

export default TASK_LIST_SECTION_TEMPLATE_DELETE;
